import {
  BaseUXComponent,
  UXComponentType
} from '../UXComponentRenderer/uxComponent.types'
import { Text } from '../primitives/Text/Text.types'
import { Image } from '../primitives/Image/Image.types'
import { Button } from '../primitives/Button/Button.types'

export enum BannerVariant {
  HERO = 'VARIANT_1',
  CARD = 'VARIANT_2'
}

export type BannerAttributes = {
  variant: BannerVariant
  title: Text
  subtitle: Text
  image: Image
  button: Button
}

export type Banner = BaseUXComponent<UXComponentType.Banner> & {
  attributes: BannerAttributes
}
